<div class="search-container">

  <form [formGroup]="formGroup">

    <lib-lookup [itemsProvider]="searchProvider"></lib-lookup>

  </form>

  <ul>

    <li (click)="setDisplayListFilter('message')" [ngClass]="{'active' : currentDisplayList === 'message'}">Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ñ</li>

    <li (click)="setDisplayListFilter('poll')" [ngClass]="{'active' : currentDisplayList === 'poll'}">ÐÐ¿ÑÐ¾ÑÑ</li>

    <li (click)="setDisplayListFilter('participants')" [ngClass]="{'active' : currentDisplayList === 'participants'}">Ð£ÑÐ°ÑÑÐ½Ð¸ÐºÐ¸</li>

  </ul>

</div>

